<template>
	<div id="butterflySearch">
		<div>
			<div>
				<b-row>
					<b-col cols="11">
						<div >
							<div >
								<h4>Search Butterfly</h4>
								<br>
								<b-row>
									<b-col cols="2">
										Scientific Name
									</b-col>
									<b-col>
										<b-form-input v-model="scientificName" v-on:keyup="onChange" @change="onChange"></b-form-input>
									</b-col>
								</b-row>
								<br>
								<b-row>
									<b-col cols="2">
										Common Name
									</b-col>
									<b-col>
										<b-form-input v-model="commonName" v-on:keyup="onChangeCommon" @change="onChangeCommon"></b-form-input>
									</b-col>
								</b-row>
								<br>
								<h5><u>Butterfly Traits</u></h5>
								<br>
								<b-row>
									<b-col cols="2">
										Size
									</b-col>
									<b-col @click="selectSize('large')">
										<div v-if="size == 'large'">
											<img src="../assets/large.png" height="150px" id="large" class="select">
										</div>
										<div v-else>
											<img src="../assets/large.png" height="150px" id="large">
										</div>
									</b-col>
									<b-col @click="selectSize('medium')">
										<div v-if="size == 'medium'">
											<img src="../assets/medium.png" height="150px" id="medium" class="select">
										</div>
										<div v-else>
											<img src="../assets/medium.png" height="150px" id="medium">
										</div>
									</b-col>
									<b-col @click="selectSize('small')">
										<div v-if="size == 'small'">
											<img src="../assets/small.png" height="150px" id="small" class="select">
										</div>
										<div v-else>
											<img src="../assets/small.png" height="150px" id="small">
										</div>
									</b-col>
								</b-row>
								<br>
								<hr>
								<b-row>
									<b-col cols="2">
										Number of legs
									</b-col>
									<b-col cols="5" @click="selectLegs('4')">
										<div v-if="legs == '4'">
											<img src="../assets/4.png" height="70px" id="four" class="select">
										</div>
										<div v-else>
											<img src="../assets/4.png" height="70px" id="four" class="selectGrey">
										</div>
									</b-col>
									<b-col cols="5" @click="selectLegs('6')">
										<div v-if="legs == '6'">
											<img src="../assets/6.png" height="70px" id="six" class="select">
										</div>
										<div v-else>
											<img src="../assets/6.png" height="70px" id="six" class="selectGrey">
										</div>
									</b-col>
								</b-row>
								<br>
								<hr>
								<b-row>
									<b-col cols="2">
										Wing Shape
									</b-col>
									<b-col @click="selectWing('heliconius')">
										<div v-if="shape == 'heliconius'">
											<img src="../assets/heliconius.jpg" height="150px" id="heliconius" class="select">
										</div>
										<div v-else>
											<img src="../assets/heliconius.jpg" height="150px" id="heliconius.jpg">
										</div>
									</b-col>
									<b-col @click="selectWing('nymphalidae')">
										<div v-if="shape == 'nymphalidae'">
											<img src="../assets/nymphalidae.jpg" height="150px" id="nymphalidae" class="select">
										</div>
										<div v-else>
											<img src="../assets/nymphalidae.jpg" height="150px" id="nymphalidae">
										</div>
									</b-col>
									<b-col @click="selectWing('papilionidae')">
										<div v-if="shape == 'papilionidae'">
											<img src="../assets/papilionidae.jpg" height="150px" id="papilionidae" class="select">
										</div>
										<div v-else>
											<img src="../assets/papilionidae.jpg" height="150px" id="papilionidae">
										</div>
									</b-col>
									<b-col @click="selectWing('pieridae')">
										<div v-if="shape == 'pieridae'">
											<img src="../assets/pieridae.jpg" height="150px" id="pieridae" class="select">
										</div>
										<div v-else>
											<img src="../assets/pieridae.jpg" height="150px" id="pieridae">
										</div>
									</b-col>
									<b-col @click="selectWing('saturniidae')">
										<div v-if="shape == 'saturniidae'">
											<img src="../assets/saturniidae.jpg" height="150px" id="saturniidae" class="select">
										</div>
										<div v-else>
											<img src="../assets/saturniidae.jpg" height="150px" id="saturniidae">
										</div>
									</b-col>
								</b-row>
								<br>
								<hr>
								<b-row>
									<b-col cols="2">
										Tails
									</b-col>
									<b-col @click="selectTail('tail')" cols="2">
										<div v-if="tail == 'tail'">
											<img src="../assets/tail.png" height="150px" id="tail" class="select">
										</div>
										<div v-else>
											<img src="../assets/tail.png" height="150px" id="tail">
										</div>
									</b-col>
									<b-col @click="selectTail('no_tail')" cols="2">
										<div v-if="tail == 'no_tail'">
											<img src="../assets/no_tail.png" height="150px" id="no_tail" class="select">
										</div>
										<div v-else>
											<img src="../assets/no_tail.png" height="150px" id="no_tail">
										</div>
									</b-col>
								</b-row>
								<br>
								<hr>
								<b-row>
									<b-col cols="2">
										Antenna
									</b-col>
									<b-col @click="selectAntenna('feathered')" cols="3">
										<div v-if="antenna == 'feathered'">
											<img src="../assets/feathered.png" height="70px" id="feathered" class="select">
										</div>
										<div v-else>
											<img src="../assets/feathered.png" height="70px" id="feathered">
										</div>
									</b-col>
									<b-col @click="selectAntenna('clubbed')" cols="3">
										<div v-if="antenna == 'clubbed'">
											<img src="../assets/clubbed.png" height="70px" id="clubbed" class="select">
										</div>
										<div v-else>
											<img src="../assets/clubbed.png" height="70px" id="clubbed">
										</div>
									</b-col>
								</b-row>
								<br>
								<hr>
								<b-row>
									<b-col cols="2">
										Resting Position
									</b-col>
									<b-col @click="selectResting('closed')" cols="3">
										<div v-if="resting == 'closed'">
											<img src="../assets/closed.png" height="150px" id="closed" class="select">
										</div>
										<div v-else>
											<img src="../assets/closed.png" height="150px" id="closed">
										</div>
									</b-col>
									<b-col @click="selectResting('open')" cols="3">
										<div v-if="resting == 'open'">
											<img src="../assets/open.png" height="150px" id="open" class="select">
										</div>
										<div v-else>
											<img src="../assets/open.png" height="150px" id="open">
										</div>
									</b-col>
								</b-row>
								<br>

							</div>
						</div>
					</b-col>
					<b-col cols="1" v-if="getUser()">
						<div class="sticky">
							<b-row class="text-center">
								<b-col>
									<b-button-group>
										<b-button @click="decreaseRows()" variant="outline-primary"><b-icon-arrow-left-short></b-icon-arrow-left-short></b-button>
										<b-button @click="increaseRowsUser()" variant="outline-primary"><b-icon-arrow-right-short></b-icon-arrow-right-short></b-button>
									</b-button-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="text-center">
									{{searchArr.filter(thisUser).length==0?0:numRows+1}}-{{(numRows+3)>searchArr.filter(thisUser).length? searchArr.filter(thisUser).length:numRows+3}}/{{searchArr.filter(thisUser).length}}
								</b-col>
							</b-row>
							<div v-for="butterfly of searchArr.filter(thisUser).slice(numRows, numRows+3)" v-bind:key="butterfly['.key']" class="onHover" @click="toButterfly(butterfly['.key'])">
								<hr>
								<b-row class="text-center">
									<b-col>{{butterfly.scientificName}}</b-col>
								</b-row>
								<b-row  class="text-center" v-if="!(butterfly.url === '')">
									<b-col><b-img-lazy :src="butterfly.url"  alt="No Image" fluid></b-img-lazy></b-col>
								</b-row>
								<b-row  class="text-center" v-else>
									<b-col>
										<img src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive" >
									</b-col>
								</b-row>

								<br>
							</div>
						</div>
					</b-col>

					<b-col cols="1" v-else>
						<div class="sticky">
							<b-row class="text-center">
								<b-col>
									<b-button-group>
										<b-button @click="decreaseRows()" variant="outline-primary"><b-icon-arrow-left-short></b-icon-arrow-left-short></b-button>
										<b-button @click="increaseRows()" variant="outline-primary"><b-icon-arrow-right-short></b-icon-arrow-right-short></b-button>
									</b-button-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="text-center">
									{{searchArr.length==0?0:numRows+1}}-{{(numRows+3)>searchArr.length? searchArr.length:numRows+3}}/{{searchArr.length}}
								</b-col>
							</b-row>
							<div v-for="butterfly of searchArr.slice(numRows, numRows+3)" v-bind:key="butterfly['.key']" class="onHover" @click="toButterfly(butterfly['.key'])">
								<hr>
								<b-row class="text-center">
									<b-col>{{butterfly.scientificName}}</b-col>
								</b-row>
								<b-row  class="text-center" v-if="!(butterfly.url === '')">
									<b-col><b-img-lazy :src="butterfly.url"  alt="No Image" fluid></b-img-lazy></b-col>
								</b-row>
								<b-row  class="text-center" v-else>
									<b-col>
										<img src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive" >
									</b-col>
								</b-row>

								<br>
							</div>
						</div>
					</b-col>
				</b-row>
			</div>
		</div>
		<div id="snackbar">{{toastMessage}}</div>
	</div>
</template>

<style>
#butterflySearch{
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	padding: 50px 50px 50px 50px;
}

div.sticky {
	position: -webkit-sticky;
	position: sticky;
	top: 90px;
	font-size: 20px;
}


.onHover:hover{
	opacity: 0.8;
	cursor: pointer;
}

.select{
	padding: 3px 3px 3px 3px;
	background-color: black;
	border-radius: 10px 10px 10px 10px;
	opacity: 0.7;
}

.selectGrey{
	padding: 3px 3px 3px 3px;
	background-color: #dbdbd9;
	border-radius: 10px 10px 10px 10px;
	opacity: 0.7;
}

#snackbar {
	visibility: hidden; /* Hidden by default. Visible on click */
	min-width: 250px; /* Set a default minimum width */
	margin-left: -125px; /* Divide value of min-width by 2 */
	background-color: #333; /* Black background color */
	color: #fff; /* White text color */
	text-align: center; /* Centered text */
	border-radius: 2px; /* Rounded borders */
	padding: 16px; /* Padding */
	position: fixed; /* Sit on top of the screen */
	z-index: 1; /* Add a z-index if needed */
	left: 45%; /* Center the snackbar */
	bottom: 30px; /* 30px from the bottom */
}

.responsive {
	width: 100%;
	height: auto;
}


#snackbar.show {
	visibility: visible; 
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
	from {bottom: 0; opacity: 0;}
	to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
	from {bottom: 0; opacity: 0;}
	to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
	from {bottom: 30px; opacity: 1;}
	to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
	from {bottom: 30px; opacity: 1;}
	to {bottom: 0; opacity: 0;}
}
</style>


<script type="text/javascript">
import { butterflyRef } from '../firebase';
import { bImagesRef } from '../firebase';

export default {
	name: 'butterflySearch',
	data () {
		return {
			butterflies: [],
			id: null,
			toastMessage: '',
			bImages: [],
			image: null,
			uploadTask: false,
			numRows: 0,
			searchArr: [],
			monthsArr: [
			{ value: 'January', text: 'January' },
			{ value: 'February', text: 'February' },
			{ value: 'March', text: 'March' },
			{ value: 'April', text: 'April' },
			{ value: 'May', text: 'May'},
			{ value: 'June', text: 'June'},
			{ value: 'July', text: 'July'},
			{ value: 'August', text: 'August'},
			{ value: 'September', text: 'September'},
			{ value: 'October', text: 'October'},
			{ value: 'November', text: 'November'},
			{ value: 'December', text: 'December'},
			],
			scientificName: '',
			commonName: '',
			family: '',
			subFamily: '',
			longevity: '',
			hostPlant: '',
			northAmerica: '',
			southAmerica: '',
			europe: '',
			africa: '',
			australia: '',
			asia: '',
			antartica: '',
			unknown: '',
			etymology: '',
			habitat: '',
			lifeHistory: '',
			startMonth: '',
			endMonth: '',
			funFact: '',
			size: '',
			legs: '',
			iridescentTop: '',
			spottedTop: '',
			stripedTop: '',
			veinsTop: '',
			iridescentBottom: '',
			spottedBottom: '',
			stripedBottom: '',
			veinsBottom: '',
			shape: '',
			tail: '',
			antenna: '',
			flower_nectar: '',
			fruit: '',
			resting: '',
			fileName: '',

		}
	},
	firebase: {
		butterflies: butterflyRef,
		bImages: bImagesRef,
		searchArr: butterflyRef
	},
	created() {
		this.id = this.$route.params.id;		
	},
	methods: {
		selectSize(size){
			if(this.size == size){
				this.size = '';
				this.onChange();
				return;
			}
			this.size = size;
			this.onChange();
		},
		selectLegs(legs){
			if(this.legs == legs){
				this.legs = '';
				this.onChange();
				return;
			}
			this.legs = legs;
			this.onChange();
		},
		selectWing(shape){
			if(this.shape == shape){
				this.shape = '';
				this.onChange();
				return;
			}
			this.shape = shape;
			this.onChange();
		},
		selectTail(tail){
			if(this.tail == tail){
				this.tail = '';
				this.onChange();
				return;
			}
			this.tail = tail;
			this.onChange();
		},
		selectAntenna(antenna){
			if(this.antenna == antenna){
				this.antenna = '';
				this.onChange();
				return;
			}
			this.antenna = antenna;
			this.onChange();
		},
		selectResting(resting){
			if(this.resting == resting){
				this.resting = '';
				this.onChange();
				return;
			}
			this.resting = resting;
			this.onChange();
		},
		showSnackBar(message){
			this.toastMessage = message;
			var x = document.getElementById("snackbar");
			x.className = "show";
			setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
		},
		increaseRows(){
			if((this.searchArr.length-this.numRows-3)>0){
				this.numRows+=3
			}
		},
		increaseRowsUser(){
			if((this.searchArr.filter(this.thisUser).length-this.numRows-3)>0){
				this.numRows+=3
			}
		},
		decreaseRows(){
			if(this.numRows>=3){
				this.numRows-=3
			}
		},
		onChange(){
			this.commonName = '';
			this.numRows =0;
			this.searchArr = [];
			for(let i=0; i<this.butterflies.length; i++){
				if(this.butterflies[i].scientificName.toLowerCase().includes(this.scientificName.toLowerCase()) || this.scientificName === ''){
					if(this.butterflies[i].tail == this.tail || this.tail === ''){
						if(this.butterflies[i].shape == this.shape || this.shape === ''){
							if(this.butterflies[i].size == this.size || this.size === ''){
								if(this.butterflies[i].antenna == this.antenna || this.antenna === ''){
									if(this.butterflies[i].resting == this.resting || this.resting === ''){
										if(this.butterflies[i].legs == this.legs || this.legs === ''){
											this.searchArr.push(this.butterflies[i]);
										}
									}
								}
							}
						}
					}
				}
			}
		},
		onChangeCommon(){
			this.scientificName = '';
			this.numRows =0;
			this.searchArr = [];
			for(let i=0; i<this.butterflies.length; i++){
				if(this.butterflies[i].commonName.toLowerCase().includes(this.commonName.toLowerCase()) || this.commonName === ''){
					if(this.butterflies[i].tail == this.tail || this.tail === ''){
						if(this.butterflies[i].shape == this.shape || this.shape === ''){
							if(this.butterflies[i].size == this.size || this.size === ''){
								if(this.butterflies[i].antenna == this.antenna || this.antenna === ''){
									if(this.butterflies[i].resting == this.resting || this.resting === ''){
										if(this.butterflies[i].legs == this.legs || this.legs === ''){
											this.searchArr.push(this.butterflies[i]);
										}
									}
								}
							}
						}
					}
				}
			}
		},
		toButterfly(key){
			this.$router.push({name:'ButterflyView', params: {id: key}})
		},
		getUser(){
			return this.$parent.activeUser?this.$parent.activeUser.name:'';
		},
		thisUser(butterfly){
			return (butterfly.user == this.getUser() || this.getUser() == 'Reiman Gardens')?butterfly:null
		}
	}
}
</script>


